import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ProcessingStatItem } from '../ProcessingStatsItem';

export const GPSStatusCount = ({ procStatsList, onChildValueChange }) => {
  const handleFCSReport = (e) => {
    e.preventDefault();
    onChildValueChange('GFB');
  };

  return (
    <ProcessingStatItem title="GPS Status Counts">
      <Table.Container title="">
        <Table.TableBody>
          <Table.Row>
            <Table.Cell>
              <Link onClick={handleFCSReport} href="#">
                Pending GPS Status Update
              </Link>
            </Table.Cell>
            <Table.Cell>
              {procStatsList?.gpsStatusCounts?.pendingGPSStatusUpdate}
            </Table.Cell>
          </Table.Row>
        </Table.TableBody>
      </Table.Container>
    </ProcessingStatItem>
  );
};
